import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { IUserManagementStore } from 'sustainment-component';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'userManagement' })
export class UserManagementStore extends Store<IUserManagementStore> {
  public constructor() {
    super({});
  }
}
